import { QueryClient } from '@tanstack/react-query';

/**
 * Invalidate every query that feeds the calendar / composer date overlay:
 * notes, holidays, festivities, and the merged calendar-events view.
 * Use after any note or holiday create/update/delete.
 */
export function invalidateCalendarOverlay(queryClient: QueryClient): void {
  queryClient.invalidateQueries({ queryKey: ['calendar-notes'] });
  queryClient.invalidateQueries({ queryKey: ['calendar-holidays'] });
  queryClient.invalidateQueries({ queryKey: ['festivities'] });
  queryClient.invalidateQueries({ queryKey: ['calendar-events'] });
}
